import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { BILLING_CONFIG } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const mutateSetBillingConfigActiveInActive = async ({
  communityId,
  pricingId,
  isActive,
}: {
  communityId: string;
  pricingId: string;
  isActive: boolean;
}) => {
  return await axiosAuth.post(
    `${BILLING_CONFIG(communityId)}/${pricingId}/active-inactive/${isActive}`
  );
};

const useSetBillingConfigActiveInActiveMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      communityId: string;
      pricingId: string;
      isActive: boolean;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateSetBillingConfigActiveInActive,
    ...queryParams,
  });

export default useSetBillingConfigActiveInActiveMutation;
